<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
    <div class="subBlockContainer" id='levelOne'>
        <div class="breadcrumbWrapper">
            <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="subBlockContent">
            <child-header title="Promotions" (closeEvent)="close()"></child-header>
            <div #ParentWrapper class="child-body" >
                <div class="item-title-wrapper">
                    <!-- <div class="title blade-title-font">
                        {{title}}
                    </div>
                    <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
                    <div class="page-title-description">
                        Check out all of Dicker Data’s current promotions in the one place. We keep this section up
                        to date with the latest offers, incentives and even your chance to win some great prizes.
                        Next time you’re making a purchase, check out how you can be rewarded for doing business
                        with Dicker Data.
                    </div>
                    <div class="top-divider"></div>
                    <div>
                        <div class="topspot-header" (click)="getCmsById('5c98273b0ebfa3188cc9dc93')">Featured Promotions
                        </div>
                        <div class="topspot-content" *ngIf="featuredPromotionList?.length > 0" style="padding-bottom: 15px;">
                            <div class="flip-featured" *ngFor="let promotion of featuredPromotionList.slice(0, 3)">
                                <div class="flip-featured-inner">
                                    <a (click)="onNavigate(promotion.id, promotion?.promotionLink)" target="_blank">
                                        <div class="flip-featured-front">
                                            <img
                                                src="https://marketingdd.blob.core.windows.net/marketing/{{promotion.cloudFileName}}"
                                                onError="this.src='https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png';"
                                                alt="" target="_blank" />
                                        </div>
                                        <div class="flip-featured-back">
                                            <div class="flip-title">{{promotion.title}}</div>
                                            <!-- <div class="font-x12 p-t-10">{{promotion.description | slice:0:200}}</div> -->
                                            <div class="flip-link"><a
                                                    (click)="onNavigate(promotion.id, promotion?.promotionLink )" target="_blank">Click to
                                                    see more
                                                    details</a></div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div class="topspot-content" *ngIf="featuredPromotionList?.length > 3">
                            <div class="flip-featured" *ngFor="let promotion of featuredPromotionList.slice(3)">
                                <div class="flip-featured-inner">
                                    <a (click)="onNavigate(promotion.id, promotion?.promotionLink)" target="_blank">
                                        <div class="flip-featured-front">
                                            <img
                                                src="https://marketingdd.blob.core.windows.net/marketing/{{promotion.cloudFileName}}"
                                                onError="this.src='https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png';"
                                                alt="" target="_blank" />
                                        </div>
                                        <div class="flip-featured-back">
                                            <div class="flip-title">{{promotion.title}}</div>
                                            <!-- <div class="font-x12 p-t-10">{{promotion.description | slice:0:200}}</div> -->
                                            <div class="flip-link"><a
                                                    (click)="onNavigate(promotion.id, promotion?.promotionLink )" target="_blank">Click to
                                                    see more
                                                    details</a></div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="featuredPromotionList.length < 1">No featured promotions to show.</div>
                    </div>
                </div>
                <div class="mTable-header">
                    <div class="row filter-wrapper">
                        <div class="col-md-3">
                            <div class="searchInputGroup">
                                <div class="searchIcon">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                    onblur="this.placeholder='Filter'" [(ngModel)]="searchField"
                                    (ngModelChange)="filterPromotionList()">
                            </div>
                        </div>
                        <div class="col-md-7">
                            <mat-form-field class="select-wrapper margin-t-x10">
                                <mat-select placeholder="Brand" multiple [(ngModel)]="selectedBrands" #brandSelect="ngModel"
                                    (selectionChange)="updateBrandList($event)">
                                    <mat-select-trigger>
                                        {{brandSelect.model ? brandSelect.model[0] : ''}}
                                        <span *ngIf="brandSelect.value?.length > 1">
                                            (+{{brandSelect.model.length - 1}} {{brandSelect.model?.length === 2 ? 'other'
                                            :
                                            'others'}})
                                        </span>
                                    </mat-select-trigger>

                                    <mat-option *ngFor="let item of promotionsBrands | UniqueFilterPipe: 'brand'"
                                        [value]="item">
                                        {{item}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-1 clearFilterButton align-center" (click)="clearFilters()">
                            Clear filter
                        </div>
                    </div>
                    <div class="top-divider"></div>
                </div>
                <div class="inner-subBlock-wrapper">
                    <div class="mTable">
                            <div *ngIf="selectedBrandPromotionList?.length > 0">
                                    <table class="white external-table">
                                        <tr class="external-row" *ngFor="let promotion of selectedBrandPromotionList">
                                            <td><img class="external-img"
                                                    src="https://marketingdd.blob.core.windows.net/marketing/{{promotion.cloudFileName}}"
                                                    onError="this.src='../images/new_ui/select-file.png';" alt="" target="_blank" />
                                            </td>
                                            <td>
                                                <div class="brand">
                                                    {{promotion.brandName}}
                                                </div>
                                                <div class="title">
                                                    {{promotion.title}}
                                                </div>
                                                <div class="description">
                                                    {{promotion.description}}
                                                </div>
                                            </td>
                                            <td class="align-center">
                                                <button (click)="onNavigate(promotion.id, promotion?.promotionLink)"
                                                    class="button button-red button-mid margin-b-x10"
                                                    target="_blank">Learn more</button><br>
                                                <img src="../images/new_ui/expiry.png">&nbsp;<span
                                                    class="expiry-text">Expiring
                                                    on
                                                    {{promotion.expiryDate | date:'dd/MM/yyyy'}}</span>
                                            </td>
                                            <div class="top-divider"></div>
                                        </tr>
                                    </table>
                                </div>
                                <div class="f-x10" *ngIf="selectedBrandPromotionList?.length < 1">No promotions to show.</div>
                    </div>

                </div>
            </div>
            <!-- <div style="overflow-y: auto;height: 100%;padding: 16px;" class="fr-view">
                <span [innerHTML]="cms?.innerHtml | sanitizeHtml" (click)="clickEvent($event)"></span>
            </div> -->
        </div>
        <loading-screen *ngIf="!loadContent" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)">
        </loading-screen>
    </div>
</div>